import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '../../ui/button';
import { OnboardingStepProps } from '../types';

export const ScanResults: React.FC<OnboardingStepProps> = ({ onNext }) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-center py-8">
        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-emerald-500/10 text-emerald-500">
          <Check className="h-8 w-8" />
        </div>
      </div>
      
      <div className="text-center">
        <h3 className="text-lg font-medium text-white">Initial Scan Complete!</h3>
        <p className="text-sm text-gray-400 mt-2">
          We've discovered your assets and identified potential security issues.
          Let's review what we found.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="p-4 bg-gray-800/30 rounded-lg">
          <div className="text-sm text-gray-400">Critical Issues</div>
          <div className="text-2xl font-bold text-red-500">2</div>
        </div>
        <div className="p-4 bg-gray-800/30 rounded-lg">
          <div className="text-sm text-gray-400">High Issues</div>
          <div className="text-2xl font-bold text-orange-500">5</div>
        </div>
        <div className="p-4 bg-gray-800/30 rounded-lg">
          <div className="text-sm text-gray-400">Medium Issues</div>
          <div className="text-2xl font-bold text-yellow-500">12</div>
        </div>
        <div className="p-4 bg-gray-800/30 rounded-lg">
          <div className="text-sm text-gray-400">Low Issues</div>
          <div className="text-2xl font-bold text-emerald-500">25</div>
        </div>
      </div>

      <Button className="w-full" onClick={onNext}>
        View Dashboard
      </Button>
    </div>
  );
};